import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { I18nProvider } from "@/lib/i18n";
import { WhatsAppButton } from "@/components/site/WhatsAppButton";
import Home from "@/pages/Home";
import RequestJourney from "@/pages/RequestJourney";
import Admin from "@/pages/Admin";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) { el.scrollIntoView({ behavior: "smooth" }); return; }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (time) => { lenis.raf(time); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  return (
    <div className="App grain">
      <I18nProvider>
        <BrowserRouter>
          <ScrollManager />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/request" element={<RequestJourney />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <WhatsAppButton />
        </BrowserRouter>
        <Toaster position="bottom-right" theme="dark" toastOptions={{ style: { background: "#16181D", border: "1px solid rgba(201,164,92,0.3)", color: "#F5F2E9", borderRadius: 0 } }} />
      </I18nProvider>
    </div>
  );
}

export default App;
